import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UtilService } from '../services/util.service';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const utilService = inject(UtilService);

  const user = authService.getUser();
  
  if (user && ['Admin', 'Super Admin'].includes(user.role)) {
    return true;
  }
  
  utilService.navigate('/app');
  return false;
};
